module.exports = __webpack_public_path__ + "static/media/nic.bc9e9471.jpg";